import './api'
import './colors'
import './components'
import './sweetalert2'
import './compositionApi'
import './moment'
import './vueCookies'
import './vueSignaturePad'
import './vueMeta'
import './gtm'
import './profileObj'
import vuetify from './vuetify'
import './filters'
import './vuelidate'
import './veevalidate'

export default {
  vuetify,
}
